import Feedback from "../feedback";
import { FaTrophy, FaEnvelope, FaClock, FaStar } from "react-icons/fa";

const ExamFinish = ({ examId, userId }) => {
  return (
    <div className="flex justify-center items-center min-h-screen" style={{ backgroundColor: 'var(--background-color)', zIndex: 9999 }}>
      <div className="w-4/5 max-w-3xl bg-var(--background-color) border border-var(--border-color) rounded-2xl p-12 text-center relative overflow-hidden shadow-2xl">
        {/* Decorative background elements */}
        <div className="absolute top-0 left-0 w-full h-2 bg-[#FC532B]"></div>
        <div className="absolute top-4 right-4 w-16 h-16 bg-[#FC532B] rounded-full opacity-20"></div>
        <div className="absolute bottom-4 left-4 w-12 h-12 bg-[#FC532B] rounded-full opacity-15"></div>
        
        {/* Success Icon */}
        <div className="relative z-10 mb-8">
          <div className="w-24 h-24 bg-[#FC532B] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
            <FaTrophy className="text-white text-4xl" />
          </div>
        </div>

        {/* Content */}
        <div className="relative z-10">
          <h2 className="text-4xl font-bold text-var(--text-color) mb-4">Congratulations!</h2>
          <h3 className="text-2xl font-semibold text-var(--text-color) mb-6">Exam Successfully Completed</h3>
          
          <div className="mb-8 p-6 bg-var(--background-color) border border-var(--border-color) rounded-xl">
            <div className="flex items-center justify-center mb-4">
              <FaEnvelope className="text-[#FC532B] text-2xl mr-3" />
              <FaClock className="text-[#FC532B] text-2xl mr-3" />
              <FaStar className="text-[#FC532B] text-2xl" />
            </div>
            <p className="text-lg text-var(--text-color) opacity-80 leading-relaxed">
              Your exam results will be sent to you via both message and email within three business days.
            </p>
          </div>

          {/* Feedback Section */}
          <div className="mt-8">
            <h4 className="text-xl font-semibold text-var(--text-color) mb-4">Share Your Experience</h4>
            <div className="bg-var(--background-color) border border-var(--border-color) rounded-xl p-6">
              <Feedback />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamFinish;
